import { render, staticRenderFns } from "./usrbalance.vue?vue&type=template&id=0b3813c0&scoped=true"
import script from "./usrbalance.vue?vue&type=script&lang=js"
export * from "./usrbalance.vue?vue&type=script&lang=js"
import style0 from "./usrbalance.vue?vue&type=style&index=0&id=0b3813c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3813c0",
  null
  
)

export default component.exports